<template>
  <div class="container-fluid">
    <inspection-form-form
      :loading="loading"
      :inspectionFormData="inspectionForm"
      :formErrors="formErrors"
      @inspectionFormSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultInspectionForm from "../defaultInspectionForm";
import InspectionFormForm from "../partials/InspectionFormForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    InspectionFormForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      inspectionForm: cloneDeep(defaultInspectionForm),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(inspectionForm) {
      this.loading = true;

      const inspectionFormData = cloneDeep(inspectionForm);
      delete inspectionFormData.id;

      try {
        await this.$store.dispatch("inspectionForms/add", inspectionFormData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("INSPECTION_FORMS.INSPECTION_FORM_ADDED"),
        });
        const inspectionForm = await this.$store.getters[
          "inspectionForms/inspectionForm"
        ];
        this.$emit("onViewInspectionForm", inspectionForm, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
